import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { Typography } from '@stories/Elements/Typography/Typography.styles';
import { Grid } from '@stories/Settings/Grids/Grid.styles';
import styled from 'styled-components';

export const ProductDetailsSection = styled.section`
  margin: 40px 0px;

  @media ${from(Device.MobileLarge)} {
    margin: 50px 0px;
  }

  @media ${from(Device.TabletLarge)} {
    margin: 60px 0px;
  }

  @media ${from(Device.Desktop)} {
    margin: 75px 0px;
  }

  @media ${from(Device.DesktopLarge)} {
    margin: 115px 0px;
  }
`;

export const ProductDetailsSectionGrey = styled.section`
  background-color: ${brand.grey['97']};

  padding: 40px 0px;

  @media ${from(Device.MobileLarge)} {
    padding: 50px 0px;
  }

  @media ${from(Device.TabletLarge)} {
    padding: 60px 0px;
  }

  @media ${from(Device.Desktop)} {
    padding: 75px 0px;
  }

  @media ${from(Device.DesktopLarge)} {
    padding: 115px 0px;
  }
`;

export const ProductDetailsSectionStyles = {
  Container: styled.section`
    margin-top: -2px;
    background-color: ${brand.grey['97']};
  `,
  Grid: styled(Grid.Default)`
    grid-row-gap: 0px !important;
  `,
  Header: styled.div`
    grid-column: span 12;
    padding: 24px 0px;
    padding-right: 16px;
    border-top: 2px solid ${brand.black};
    cursor: pointer;
    user-select: none;
  `,
  HeaderInner: styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
  `,
  SubHeader: styled.div``,
  Footer: styled.div`
    border-bottom: 2px solid ${brand.black};
  `,
  Content: styled.div`
    padding-bottom: 24px;
  `,
  Title: styled(Typography.H3)`
    margin-bottom: 0px;
    padding-right: 12px;
    ${fonts.helvetica['97-black-condensed']};
  `,
  Toggle: styled.span`
    width: 24px;
    height: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    svg {
      width: 24px;
      height: 24px;
    }
  `,
  LegacyContainer: styled.div`
    padding: 20px;
  `,
};
